module.exports = __webpack_public_path__ + "static/img/brand-second-4-1-new.25fb8d40.png";